import * as types from '../actions/actionType'

const initialState = {
}
initialState.checkPermissions = {
    ///EXCEL REPORTS///
   hasHaadPenalty: false,
   hasChargesReport: false,
   hasQuotationStatistics: false,
   ///EXCEL REPORTS///
}

export default function transactionReducer(state = initialState, action) {
    switch (action.type) {
        case types.UPDATE_TRANSACTION_MODULE_PERMISSIONS_PARAMS: {
            return {
                ...state,
                checkPermissions: {
                    ...state.checkPermissions,
                    [action.payload.name]: action.payload.value
                }
            }
        }
        default:
            return state;
    }
}

